import {ActionCreatorDefinition, createAction} from "redux-ts";
import {InboxMessage, PushNotification} from "core/redux/inbox/InboxReduxState";
import {NotificationTab} from "enum/NotificationTab";

export const SetNotificationTabType: string =  "SetNotificationTab";
export const FetchInboxMessagesType: string = "FetchInboxMessages";
export const SetInboxMessagesType: string = "SetInboxMessages";
export const AddInboxMessageType: string =  "AddInboxMessage";
export const RemoveInboxMessageType: string =  "RemoveInboxMessage";
export const ResetInboxUnreadCountType: string =  "ResetInboxUnreadCount";
export const SetPushNotificationType: string = "SetPushNotification";
export const RemovePushNotificationType: string = "RemovePushNotification";

export interface SetNotificationTabPayload {

    tab: NotificationTab;
}

export interface FetchInboxMessagesPayload {

    startIndex: number;
    stopIndex: number;
    resolve?: (value: any) => void;
    reject?: () => void;
}

export interface SetInboxMessagesPayload {

    messages: InboxMessage[];
}

export interface AddInboxMessagePayload {

    message: InboxMessage;
}

export interface RemoveInboxMessagePayload {

    message: InboxMessage;
}

export interface SetPushNotificationPayload {

    message: PushNotification;
}

export const SetNotificationTab: ActionCreatorDefinition<SetNotificationTabPayload, any> = createAction<SetNotificationTabPayload>(SetNotificationTabType);
export const FetchInboxMessages: ActionCreatorDefinition<FetchInboxMessagesPayload, any> = createAction<FetchInboxMessagesPayload>(FetchInboxMessagesType);
export const SetInboxMessages: ActionCreatorDefinition<SetInboxMessagesPayload, any> = createAction<SetInboxMessagesPayload>(SetInboxMessagesType);
export const AddInboxMessage: ActionCreatorDefinition<AddInboxMessagePayload, any> = createAction<AddInboxMessagePayload>(AddInboxMessageType);
export const RemoveInboxMessage: ActionCreatorDefinition<RemoveInboxMessagePayload, any> = createAction<RemoveInboxMessagePayload>(RemoveInboxMessageType);
export const ResetInboxUnreadCount: ActionCreatorDefinition<any, any> = createAction<any>(ResetInboxUnreadCountType);
export const SetPushNotification: ActionCreatorDefinition<SetPushNotificationPayload, any> = createAction<any>(SetPushNotificationType);
export const RemovePushNotification: ActionCreatorDefinition<any, any> = createAction<any>(RemovePushNotificationType);
